import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-feedback-toggle',
  templateUrl: './feedback-toggle.component.html',
  styleUrls: ['./feedback-toggle.component.scss']
})
export class FeedbackToggleComponent {
  @Input() sessionId!: string;
  @Input() resultCode!: string;
  @Input() initialState: 'up' | 'down' | null = null;
  @Output() feedbackChange = new EventEmitter<{ sessionId: string, resultCode: string, state: 'up' | 'down' | null }>();

  feedbackState: 'up' | 'down' | null = null;

  ngOnInit() {
    this.feedbackState = this.initialState;
  }

  toggle(state: 'up' | 'down') {
    if (this.feedbackState === state) {
      this.feedbackState = null;
    } else {
      this.feedbackState = state;
    }
    this.feedbackChange.emit({ sessionId: this.sessionId, resultCode: this.resultCode, state: this.feedbackState });
  }
}
